export default {
  registration: {
    header: {
      title: 'หน้าลงทะเบียนซัพพลายเออร์',
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: 'นี่คือหน้าลงทะเบียนผู้ใช้สำหรับบริษัทที่ได้รับการร้องขอให้ใช้บริการนี้',
      section_two: 'โปรดป้อนรหัสผ่านเพื่อเข้าสู่หน้าลงทะเบียน',
      section_three: 'หากคุณไม่ได้รับรหัสผ่าน โปรดติดต่อบริษัทที่ร้องขอเพื่อใช้บริการนี้',
      passcode: 'รหัสผ่าน',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'อินพุตไม่ถูกต้อง',
      unexpected_error: 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'โปรดกรอกที่อยู่อีเมลของคุณเพื่อลงทะเบียน',
      email: 'ที่อยู่อีเมล',
      email_placeholder: 'กรอกที่อยู่อีเมล',
    },
    sent: {
      section_one: 'ระบบได้ส่งอีเมลไปยังที่อยู่อีเมลที่คุณให้ไว้',
      section_two: 'โปรดตรวจสอบ URL ในอีเมลและดำเนินการลงทะเบียนบัญชี',
      section_three: 'หากคุณไม่ได้รับอีเมลภายใน 30 นาที โปรดติดต่อ',
      section_four: '',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: 'ที่อยู่อีเมลที่คุณป้อนถูกใช้สำหรับบัญชี ASUENE/ASUENE ESG แล้ว',
      section_two: 'โปรดเข้าสู่ระบบด้วยรหัสผ่านของคุณ',
      password: 'รหัสผ่าน',
      // password_placeholder: '',
      error_auth: 'ตรวจสอบสิทธิ์ไม่สำเร็จ โปรดเข้าสู่ระบบอีกครั้ง',
      // error_linking: '',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'โปรดป้อนข้อมูลที่จำเป็นเพื่อดำเนินการลงทะเบียนของคุณให้เสร็จสิ้น',
      section_three: 'โปรดเข้าสู่ระบบด้วยบัญชีที่ลงทะเบียนของคุณหลังจากการสมัคร แล้วคุณจะสามารถตอบแบบสำรวจใหม่ได้',
      buyer_name: 'ผู้ซื้อ',
      // expires_date: '',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'ชื่อบริษัท',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: 'ที่อยู่อีเมลที่คุณป้อนจะปรากฏขึ้น',
      phone: 'หมายเลขโทรศัพท์',
      phone_placeholder: '0000000000',
      locale: 'เลือกภาษา',
      section_one: 'โปรดยอมรับ',
      rule: 'ข้อกำหนดและเงื่อนไข',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' และ ',
      policy: 'นโยบายความเป็นส่วนตัว',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: 'ก่อนดำเนินการต่อ',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'ขอบคุณสำหรับการลงทะเบียนของคุณ',
      section_two: 'เราได้ส่ง ID เข้าสู่ระบบและรหัสผ่านของคุณไปยังที่อยู่อีเมลที่คุณป้อนแล้ว',
      section_three: 'โปรดตรวจสอบอีเมลของคุณและปฏิบัติตามคำแนะนำในอีเมลเพื่อเข้าสู่ระบบ',
      section_four: 'หากคุณไม่ได้รับอีเมลภายใน 30 นาที โปรดติดต่อ ',
      section_five: '',
      section_six: 'ผู้รับผิดชอบจะติดต่อคุณ',
    },
    expired: {
      section_one: 'URL ที่ให้หมดอายุแล้ว',
      section_two: 'หากคุณต้องการใช้บริการนี้ โปรดติดต่อ ',
      section_three: 'ผู้รับผิดชอบจะติดต่อคุณ',
    },
    error: {
      section_one: 'ไม่พบ URL ที่ให้',
      section_two: 'ขออภัยในความไม่สะดวก โปรดตรวจสอบ URL อีกครั้ง',
    },
    btn: {
      submit: 'ส่ง',
      service_top: 'ด้านบน',
      login: 'เข้าสู่ระบบ',
      register: 'ลงทะเบียน',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
